export default __webpack_public_path__ + "static/media/pwa get 50 interactions.5e46e729.png";